import DialogError from './DialogError';

export default DialogError;
